import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/layout/admin';
import * as Unicons from '@iconscout/react-unicons';
import { FiChevronRight, FiDownload, FiEdit, FiEye } from 'react-icons/fi';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import './styles.scss';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getRaterFormDetail } from '../../services/raterForm';
import { Card, Drawer, Flex, Popover, Text } from '@mantine/core';
import Button from '../../components/elements/Button';
import './styles.scss';
import DetailFormMethod from '../../components/fragments/DetailFormMethod';
import { RaterGroups } from '../../types/rater';
import { renderDate } from '../../utilities/renderDate';
import { useDisclosure } from '@mantine/hooks';

export const raterDataType = [
  'Reliability',
  'Assurance',
  'Tangibles',
  'Empathy',
  'Responsiveness'
];

const PrincipalRaterFormDetailPage = (props) => {
  const params: any = useParams();
  const [dataRater, setDataRater] = useState<RaterGroups>(null);

  // Queries
  const fetchedRaterForm = useQuery({
    queryKey: ['getRaterFormDetail'],
    queryFn: () => getRaterFormDetail(params?.id)
  });

  const [opened, { open, close }] = useDisclosure(false);
  const [index, setIndex] = useState(0);
  const [insertID, setInsertID] = useState('');
  const [noteList, setNoteList] = useState(null);
  const [notesExpectation, setNotesExpectation] = useState(null);

  useEffect(() => {
    if (
      fetchedRaterForm?.data?.data?.data &&
      fetchedRaterForm?.data?.data?.data.length > 0
    ) {
      if (
        fetchedRaterForm?.data?.data?.data[index]?.listData &&
        fetchedRaterForm?.data?.data?.data[index]?.listData.length > 0
      ) {
        const grouped = fetchedRaterForm?.data?.data?.data[
          index
        ]?.listData.reduce((acc, item) => {
          const key = item.jenis;
          if (raterDataType.includes(key)) {
            acc[key].push(item);
          }
          return acc;
        }, Object.fromEntries(raterDataType.map((jenis) => [jenis, []])));

        setDataRater(grouped);

        const mapping = {
          Reliability: ['R1'],
          Assurance: ['A'],
          Tangibles: ['T'],
          Empathy: ['E'],
          Responsiveness: ['R2']
        };

        const results = raterDataType.reduce((acc, category) => {
          acc[category] = fetchedRaterForm?.data?.data?.data[
            index
          ]?.notes.filter((item) => mapping[category].includes(item.jenis));
          return acc;
        }, {});

        setNoteList(results);

        const resultNotesExpectation = raterDataType.reduce((acc, category) => {
          acc[category] = fetchedRaterForm?.data?.data?.data[
            index
          ]?.notesExpectation.filter((item) =>
            mapping[category].includes(item.jenis)
          );
          return acc;
        }, {});

        setNotesExpectation(resultNotesExpectation);
      }
    }
  }, [fetchedRaterForm?.data?.data?.data, index]);

  const grandTotalExpectation = fetchedRaterForm?.data?.data?.data[index]
    ?.rataexpectation
    ? fetchedRaterForm?.data?.data?.data[index]?.rataexpectation.toFixed(2)
    : 0;
  const grandTotalRater = fetchedRaterForm?.data?.data?.data[index]?.ratarater
    ? fetchedRaterForm?.data?.data?.data[index]?.ratarater.toFixed(2)
    : 0;

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="RATER Form Detail"
        itemList={[
          {
            title: 'RATER',
            href: '#',
            icon: <Unicons.UilFileCopyAlt size={16} />
          },
          {
            title: 'RATER Form',
            href: '/principal/rater-form'
          },
          {
            title: 'RATER Form Detail',
            href: '#'
          }
        ]}
      />
      <Drawer
        opened={opened}
        onClose={close}
        title="Update Trail"
        position={'right'}
      >
        {fetchedRaterForm?.data?.data?.data.map((item, index) => (
          <Card
            withBorder
            radius={'lg'}
            mt={index === 0 ? 0 : 10}
            style={{
              cursor: 'pointer',
              borderColor: insertID === item.updatedId ? 'purple' : '#E0E0E0',
              borderWidth: insertID === item.updatedId ? '2px' : '1px'
            }}
          >
            <Flex
              key={index}
              align="center"
              justify="space-between"
              className={`rater-form-detail__drawer-item ${
                index === 0 ? 'active' : ''
              }`}
              onClick={() => {
                setInsertID(item.updatedId);
                setIndex(index);
                close();
              }}
            >
              <div>
                <Text>{item.userIn}</Text>
                <Text
                  style={{
                    color: '#9E9E9E',
                    fontSize: '12px'
                  }}
                >
                  {renderDate(item.dateIn, 'datetime')}
                </Text>
                <Text
                  style={{
                    color: '#9E9E9E',
                    fontSize: '12px'
                  }}
                >
                  Click to see the detail
                </Text>
              </div>
              <div>
                <FiChevronRight />
              </div>
            </Flex>
          </Card>
        ))}
      </Drawer>

      <Flex direction={{ base: 'column', sm: 'row' }} mb={16} gap={16}>
        <Flex
          direction={{ base: 'column', sm: 'row' }}
          flex={1}
          gap={16}
          align="flex-start"
        >
          <Flex direction="column">
            <p className="rater-form-detail__title m-0">Submitted Date</p>
            <h5 className="rater-form-detail__description m-0">
              {fetchedRaterForm?.data?.data?.data[index]?.dateIn
                ? renderDate(
                    fetchedRaterForm?.data?.data?.data[index]?.dateIn,
                    'datetime'
                  )
                : '-'}
            </h5>
          </Flex>
          <Flex direction="column">
            <p className="rater-form-detail__title m-0">Submitted By</p>
            <h5 className="rater-form-detail__description m-0">
              {fetchedRaterForm?.data?.data?.data[index]?.userIn || '-'}
            </h5>
          </Flex>
          <Flex direction="column">
            <p className="rater-form-detail__title m-0">
              Expectation Grand Total Score
            </p>
            <h5 className="rater-form-detail__description m-0">
              {grandTotalExpectation}
            </h5>
          </Flex>
          <Flex direction="column">
            <p className="rater-form-detail__title m-0">
              RATER Grand Total Score
            </p>
            <h5 className="rater-form-detail__description m-0">
              {grandTotalRater}
            </h5>
          </Flex>
        </Flex>
        <Flex direction={{ base: 'column', sm: 'row' }}>
          {/* <div>
            <Button leftSection={<FiDownload size={24} />}>Download</Button>
          </div> */}
          {/* <div
            style={{
              marginLeft: '10px'
            }}
          >
            <Button
              leftSection={<FiEdit size={24} />}
              variant={'outline'}
              onClick={() => {
                props.history.push(
                  `/management/rater-form/detail/edit/${params.id}/${fetchedRaterForm?.data?.data?.data[0]?.binusianID}`
                );
              }}
            ></Button>
          </div> */}
          {fetchedRaterForm?.data?.data?.data.length > 1 && (
            <div
              style={{
                marginLeft: '10px'
              }}
            >
              <Button
                leftSection={<FiEye size={24} />}
                variant={'outline'}
                onClick={open}
              ></Button>
            </div>
          )}
        </Flex>
      </Flex>
      <Flex justify={'center'} mb={16}>
        <h3 className="rater-form-detail__title-rater m-0">
          EXPECTATION QUESTIONS USING <strong> R.A.T.E.R </strong> METHOD
        </h3>
      </Flex>

      <Flex gap={16} direction="column">
        {dataRater &&
          raterDataType.map((item, index) => {
            return (
              <DetailFormMethod
                title={item}
                notes={noteList && noteList[item]}
                notesExpectation={notesExpectation && notesExpectation[item]}
                data={dataRater[item]}
                key={index}
              />
            );
          })}
      </Flex>

      <Flex
        gap={4}
        align="center"
        justify="flex-start"
        p={16}
        mt={16}
        className="wrapper-grand-total"
      >
        <Popover width={200} position="bottom" withArrow shadow="md">
          <Popover.Target>
            <div className="summary-table-method__button_information">
              <Unicons.UilInfoCircle size={20} />
            </div>
          </Popover.Target>
          <Popover.Dropdown>
            <Text size="xs" fw={700}>
              Grand Total
            </Text>
            <Text size="xs">
              Is the result of the total rating score divided by 5 aspects
            </Text>
          </Popover.Dropdown>
        </Popover>

        <Text size="md" fw={700}>
          Grand Total : {grandTotalRater}
        </Text>
      </Flex>
    </AdminLayout>
  );
};

export default PrincipalRaterFormDetailPage;
